/* eslint-disable */

/**
 * Copyright (c) Grab
 * Grab Design Tokens Project
 * Do not edit directly
 */

export const gdsColorNeutral50 = '#f5f5f5';
export const gdsColorNeutral75 = '#e8e8e8';
export const gdsColorNeutral100 = '#dbdbdb';
export const gdsColorNeutral200 = '#bfbfbf';
export const gdsColorNeutral300 = '#a3a3a3';
export const gdsColorNeutral400 = '#8c8c8c';
export const gdsColorNeutral500 = '#707070';
export const gdsColorNeutral600 = '#575757';
export const gdsColorNeutral700 = '#3d3d3d';
export const gdsColorNeutral800 = '#292929';
export const gdsColorNeutral900 = '#1a1a1a';
export const gdsColorNeutralWhite = '#ffffff';
export const gdsColorNeutralBlack = '#000000';
export const gdsColorNeutralCool50 = '#f3f6fb';
export const gdsColorNeutralCool75 = '#e5e9f0';
export const gdsColorNeutralCool100 = '#d7dce4';
export const gdsColorNeutralCool200 = '#bac0c9';
export const gdsColorNeutralCool300 = '#9fa4ad';
export const gdsColorNeutralCool400 = '#868d95';
export const gdsColorNeutralCool500 = '#697078';
export const gdsColorNeutralCool600 = '#50565e';
export const gdsColorNeutralCool700 = '#383e43';
export const gdsColorNeutralCool800 = '#242a2e';
export const gdsColorNeutralCool900 = '#161a1d';
export const gdsColorSlate50 = '#f0f2ff';
export const gdsColorSlate75 = '#e1e7f6';
export const gdsColorSlate100 = '#d2dcee';
export const gdsColorSlate200 = '#b2c0d7';
export const gdsColorSlate300 = '#94a4c2';
export const gdsColorSlate400 = '#798aaf';
export const gdsColorSlate500 = '#606f90';
export const gdsColorSlate600 = '#485774';
export const gdsColorSlate700 = '#303d55';
export const gdsColorSlate800 = '#1f293d';
export const gdsColorSlate900 = '#131a25';
export const gdsColorGreen50 = '#d9fcde';
export const gdsColorGreen75 = '#c6f4cc';
export const gdsColorGreen100 = '#b1eaba';
export const gdsColorGreen200 = '#78d389';
export const gdsColorGreen300 = '#3cb95a';
export const gdsColorGreen400 = '#00b14f';
export const gdsColorGreen500 = '#00804a';
export const gdsColorGreen600 = '#03633e';
export const gdsColorGreen700 = '#005339';
export const gdsColorGreen800 = '#002e27';
export const gdsColorGreen900 = '#001e1f';
export const gdsColorGreenA50 = '#e8fccf';
export const gdsColorGreenA75 = '#e1f689';
export const gdsColorGreenA100 = '#d3f035';
export const gdsColorGreenA200 = '#8cd421';
export const gdsColorGreenA300 = '#5ab828';
export const gdsColorBlue50 = '#ebfaff';
export const gdsColorBlue75 = '#ccf2ff';
export const gdsColorBlue100 = '#b3ebff';
export const gdsColorBlue200 = '#86d8f9';
export const gdsColorBlue300 = '#3ab5ee';
export const gdsColorBlue400 = '#1495e6';
export const gdsColorBlue500 = '#136fd8';
export const gdsColorBlue600 = '#0b54a8';
export const gdsColorBlue700 = '#0a3d71';
export const gdsColorBlue800 = '#0c2b45';
export const gdsColorBlue900 = '#0b1b23';
export const gdsColorOrange50 = '#fff4eb';
export const gdsColorOrange75 = '#ffe3cc';
export const gdsColorOrange100 = '#ffd3ad';
export const gdsColorOrange200 = '#ffb570';
export const gdsColorOrange300 = '#ff8404';
export const gdsColorOrange400 = '#f76708';
export const gdsColorOrange500 = '#ca3e07';
export const gdsColorOrange600 = '#9e3105';
export const gdsColorOrange700 = '#712304';
export const gdsColorOrange800 = '#4f1803';
export const gdsColorOrange900 = '#310f02';
export const gdsColorYellow50 = '#fff9c0';
export const gdsColorYellow75 = '#ffec8f';
export const gdsColorYellow100 = '#ffd933';
export const gdsColorYellow150 = '#ffc905';
export const gdsColorYellow200 = '#ffbc05';
export const gdsColorYellow250 = '#faab00';
export const gdsColorYellow300 = '#f09800';
export const gdsColorYellow350 = '#e58a00';
export const gdsColorYellow400 = '#cc7a00';
export const gdsColorYellow500 = '#a55f03';
export const gdsColorYellow600 = '#824703';
export const gdsColorRed50 = '#fdf2f2';
export const gdsColorRed75 = '#ffe2df';
export const gdsColorRed100 = '#ffd2cc';
export const gdsColorRed200 = '#ffa799';
export const gdsColorRed300 = '#ff7f6b';
export const gdsColorRed400 = '#f55538';
export const gdsColorRed500 = '#d42e1c';
export const gdsColorRed600 = '#ac1e11';
export const gdsColorRed700 = '#79150c';
export const gdsColorRed800 = '#530e08';
export const gdsColorRed900 = '#380a06';
export const gdsColorIntegrityTeal50 = '#defbfc';
export const gdsColorIntegrityTeal75 = '#a4f6f9';
export const gdsColorIntegrityTeal100 = '#61eff5';
export const gdsColorIntegrityTeal200 = '#0fd4db';
export const gdsColorIntegrityTeal300 = '#01b5bc';
export const gdsColorIntegrityTeal400 = '#009da3';
export const gdsColorIntegrityTeal500 = '#008388';
export const gdsColorIntegrityTeal600 = '#066165';
export const gdsColorIntegrityTeal700 = '#0b4446';
export const gdsColorIntegrityTeal800 = '#0f2d2f';
export const gdsColorIntegrityTeal900 = '#0b1d1e';
export const gdsColorDuxtonBlue50 = '#eef9f9';
export const gdsColorDuxtonBlue75 = '#d2edea';
export const gdsColorDuxtonBlue100 = '#b8e5df';
export const gdsColorDuxtonBlue200 = '#84d2ca';
export const gdsColorDuxtonBlue300 = '#4ab5aa';
export const gdsColorDuxtonBlue400 = '#2d9f94';
export const gdsColorDuxtonBlue500 = '#277c74';
export const gdsColorDuxtonBlue600 = '#206059';
export const gdsColorDuxtonBlue700 = '#184440';
export const gdsColorDuxtonBlue800 = '#0f2e2b';
export const gdsColorDuxtonBlue900 = '#091a19';

/** @deprecated */
export const gdsColorWhite = gdsColorNeutralWhite;
/** @deprecated */
export const gdsColorBlack = gdsColorNeutralBlack;
